<template>
  <div id="app" :class="{ hui: $route.path == '/index' }">
    <!-- <template v-if="accessibleMode"> -->
    <!-- <div class="AccessibleToolbar-block"></div> -->
    <!-- <AccessibleToolbar></AccessibleToolbar> -->
    <!-- </template> -->
    <!-- <img src="./assets/images/esdphbg3.png" class="sss" alt="" /> -->
    <router-view />
    <!-- <keep-alive v-if="$router.meta && $router.meta.keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else /> -->
  </div>
</template>
<script>
// import AccessibleToolbar from "@/components/AccessibleToolbar.vue";
// import { mapState } from "vuex";
export default {
  // components: { AccessibleToolbar },
  computed: {
    // ...mapState(["accessibleMode"]),
  },
  created() {
    console.log(this.$route);
  }
};
</script>

<style lang="scss">
#app {
  // filter: grayscale(100%);
  // .sss{
  //   width: 1920px;
  //   position: absolute;
  //   top: 0; 
  //   left: 0;
  //   z-index: -1;
  // }
}

.AccessibleToolbar-block {
  display: block;
  height: 110px;
}
</style>
